const order = {
  state: {
    R_ID: '', // 房台ID
    RoomName: '', // 房台名称
    MT_ID: '', // 主单ID
    MT_State: '', // 房台状态
    CS_Name: '', // 场所名称
    YuShouJinE: 0, // 预收金额
    VipInfo: [], // 操作员会员列表
    ZW_Right_InputFolio: '', // 操作员落单权限
    shopCarList: [], // 购物车列表
    foodTypeList: [], // 类别列表
    foodList: [], // 菜品列表
    searchFoodList: [], // 查找菜品列表
    Lat: '',
    Lng: '',
    KeDianDanFanWei: '',
    vodType: '',
    weappId: '',
    creatOrderUrl: '',
    storeId: '',
    orderFromType: '',
  },
  mutations: {
    SET_SYATEMS(state, data) {
      const { Bill } = data
      state.MT_ID = Bill && Bill.MT_ID
      state.R_ID = Bill && Bill.R_ID
      state.RoomName = Bill && Bill.RoomName
      state.CS_Name = data.CS_Name
      state.MT_State = Bill && Bill.MT_State
      state.YuShouJinE = data.YuShouJinE
      state.ZW_Right_InputFolio = data.ZW_Right_InputFolio
      state.Lat = data.Lat
      state.Lng = data.Lng
      state.KeDianDanFanWei = data.KeDianDanFanWei
    },
    SET_SHOPCARLIST(state, data) {
      state.shopCarList = data
    },
    SET_LITONG_SYATEMS(state, data) {
      state.weappId = data.weappId
      state.creatOrderUrl = data.creatOrderUrl
      state.storeId = data.creatOrderUrl.split('?')[1].split('=')[1]
    },
    SET_VOD_TYPE(state, data) {
      state.vodType = data
    },
    SET__ORDER_FROM_TYPE(state, data) {
      state.orderFromType = data
    },
  },
}
export default order
